import toast from "react-hot-toast";
import axiosInstant from "../api";

interface SetVideosApprovalOptions {
    url?: string | null;
    approve: boolean;
    onDone?: () => void;
}

export const setVideosApproval = async ({
    url,
    approve,
    onDone,
}: SetVideosApprovalOptions): Promise<void> => {
    if (!url) return;

    const pastTense = approve ? "approved" : "unapproved";
    const toastId = toast.loading(`${approve ? "Approving" : "Unapproving"} videos...`);

    try {
        const { data } = await axiosInstant.patch(url, { final: approve });
        const updated = data?.updated ?? 0;
        toast.success(
            updated === 0
                ? `All videos are already ${pastTense}.`
                : `${updated} ${updated === 1 ? "video" : "videos"} ${pastTense} successfully.`,
            { id: toastId },
        );
    } catch (err: any) {
        toast.error(err?.response?.data?.error ?? `Failed to ${approve ? "approve" : "unapprove"} videos.`, {
            id: toastId,
        });
    } finally {
        onDone?.();
    }
};
